import { createSlice } from "@reduxjs/toolkit"

export const assessmentSlice = createSlice(
  {
    name: "assessmentData",
    initialState: {
      assessmentInfo: {
        "id": "",
        "comment": "",
        "createdAt": null,
        "currentYear": null,
        "evidences": [],
        "isSubmited": false,
        "markings": [],
        "firstName": "",
        "lastName": "",
        "outcome": "",
        "pupilId": "",
        "updatedAt": null
      },
      latestAssessment: [],
      currentYear: 0,
      addNewAssessment: false,
      mappixArray: [],
      mappixMatrix: [],
      assessmentOutcome: ""
    },
    reducers: {
      setAssessmentInfo: (state, action) => {
        state.assessmentInfo = action.payload
      },
      setMarkingInfo: (state, action) => {
        state.assessmentInfo.markings = action.payload
      },
      setMappixArray: (state, action) => {
        state.mappixArray = action.payload
      },
      setMappixMatrix: (state, action) => {
        state.mappixMatrix = action.payload
      },
      setMark: (state, action) => {
        state.assessmentInfo.markings = action.payload
      },
      setId: (state, action) => {
        state.assessmentInfo.id = action.payload;
      },
      setAssessmentYear: (state, action) => {
        state.currentYear = action.payload
      },
      setFirstName: (state, action) => {
        state.assessmentInfo.firstName = action.payload
      },
      setLastName: (state, action) => {
        state.assessmentInfo.lastName = action.payload
      },
      setPupilId: (state, action) => {
        state.assessmentInfo.pupilId = action.payload
      },
      setIsSubmited: (state, action) => {
        state.assessmentInfo.isSubmited = action.payload
      },
      setLatestAssessment: (state, action) => {
        state.latestAssessment = action.payload
      },
      setAddNewAssessment: (state, action) => {
        state.addNewAssessment = action.payload
      },
      setAssessmentOutcome: (state, action) => {
        state.assessmentOutcome = action.payload
      }
    },
  },

)


// Action creators are generated for each case reducer function
export const { setAssessmentInfo, setMarkingInfo, setMark, setId, setAssessmentOutcome, setAssessmentYear, setFirstName, setIsSubmited, setPupilId, setLastName, setLatestAssessment, setAddNewAssessment } = assessmentSlice.actions

export default assessmentSlice.reducer